import React from 'react';
import { maskPhone } from '../../masks';

const ContactInformationBar = props => {
  const { email, unconfirmed_email, phone } = props;
  return (
    <div className="cms_bar contact-info-bar">
      {renderEmail(email)}
      {renderPhone(phone)}
      {renderEmail(unconfirmed_email, true)}
    </div>
  );
};

const renderPhone = phone => {
  return phone ? (
    <div className="contact-info-bar__phone">
      {maskPhone(phone)}
    </div>
  ) : (
    ''
  );
};

const renderEmail = (email, unconfirmed = false) => {
  const classes = ['contact-info-bar__email'];
  if (unconfirmed) classes.push('contact-info-bar__email--unconfirmed');
  return email ? (
    <a className={classes.join(' ')} href={'mailto:' + email}>
      {email}
      {unconfirmed && <span> (pending)</span>}
    </a>
  ) : (
    ''
  );
};

export default ContactInformationBar;



// WEBPACK FOOTER //
// ./src/components/shared/ContactInformationBar.js